import React, { useEffect, useState, useMemo } from "react";
import FormGenerator from "../../../../../../Components/FormGenerator";
import { useDispatch, useSelector } from "react-redux";
import { SetContactArea, UpdateContactAreaError } from "./ContactAreaActions";
import { useLocation, useParams } from "react-router";

// const theme = createMuiTheme({
//   overrides: {
//     MuiFormControl: {
//       root: {
//         width: "100%",
//       },
//     },
//   },
// });

export default function ContactArea(props) {
  const dispatch = useDispatch();
  const [countyList, setCountyList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [languageListsArr, setLanguageListsArr] = useState([]);

  const {
    title_id,
    first_name,
    middle_name,
    last_name,
    authorisation_to_access_the_service,
    authorisation_provided_by,
    suffixes,
    gender_id,
    dob,
    nationality_list_id,
    bame,
    languages_list,
    address_line1,
    address_line2,
    country_list_id,
    city,
    ethnicity,
    county,
    zipcode,
    primary_email,
    secondary_email,
    mobile,
    phone,
    linkedin,
    skype,
    twitter,
    facebook,
    website1,
    website2,
    postcode,
    picture,
    address,
    access_level,
  } = useSelector((state) => state.contactAreaReducer.data);

  const errors = useSelector((state) => state.contactAreaReducer.errors);
  const globaluserData = useSelector((state) => state.commonReducer);
  const userRole = globaluserData?.role;
  // const userRole = sessionStorage.getItem("role");
  const [feildIsMandatory, setFeildIsMandatory] = useState(true);
  useEffect(() => {
    if (userRole === "employee") {
      setFeildIsMandatory(false);
    }
  }, []);
  const hideField = [
    "Authorisation to access the service Y/N",
    "Authorisation provided by",
    "BAME",
    "Diversity and Inclusion",
    "Home Town/City",
    "Home County",
    "Home Country",
    "Home Post/ Zip Codes",
  ];

  const hideAdminFields = [
    "address",
    "address_line1",
    "address_line2",
    "city",
    "county",
    "country_list_id",
    "postcode"
  ];

  const handleInputChange = (value, index, type) => {
    props.setSomeChangeDetected(true);
    const updatedForm = formInput;
    if (!type) {
      updatedForm[index]["value"] = value;
    } else {
      updatedForm[index][type] = value;
    }
    setFormInput(updatedForm);
    const formData = {};
    formInput.forEach((item, fIndex) => {
      // if (item.value || item.inputValue || item.selectValue) {
      //   item.value && (formData[item.name] = item.value);
      //   item.inputValue && (formData[item.inputName] = item.inputValue);
      //   item.selectValue && (formData[item.selectName] = item.selectValue);
      //   dispatch(SetContactArea(formData));
      // }
      if (fIndex === index) {
        formData[item.name] = item.value ?? "";
        formData[item.inputName] = item.inputValue ?? "";
        formData[item.selectName] = item.selectValue ?? "";
        dispatch(SetContactArea(formData));
      }
    });
    dispatch(UpdateContactAreaError(updatedForm[index].name));
  };

  const {
    // suffixes,
    genders,
    titles,
    country_lists,
    language_lists,
    access_levels,
  } = useSelector((state) => state.commonReducer.employeeDropdowns);

  const suffixesSelector = useSelector(
    (state) => state.commonReducer.employeeDropdowns.suffixes
  );

  // Form disabling logic
  const location = useLocation();
  // let { organisation_id, employee_id } = JSON.parse(
  //   globaluserData.userData
  //   // sessionStorage.getItem("user")
  // )?.data;
  let organisation_id = globaluserData.organisation_id; 
  let employee_id = globaluserData.employee_id; 
  const params = useParams();
  let unEditable = false;
  const isSameEmployee =
    userRole === "employee" &&
    Number(params.id) === Number(organisation_id) &&
    Number(employee_id) === Number(params.employeeid);
  if (location?.state?.unEditable && !isSameEmployee) {
    unEditable = true;
  }

  const formDisabler = (el) => {
    if (unEditable) {
      return { ...el, disabled: true };
    } else {
      return el;
    }
  };

  const formArray = [
    {
      componentType: "SelectSpecific",
      label: "Title",
      autoFocus: true,
      helperText: errors && errors.title_id && "Please select a title",
      name: "title_id",
      value: title_id,
      placeholder: "Title",
      selectOptions: titles,
      handleChange: handleInputChange,
      dropDown: "Title",
      field_name: "title",
    },
    {
      componentType: "input",
      type: "text",
      label: "First name*",
      helperText: errors && errors.first_name && "Please enter first name",
      name: "first_name",
      value: first_name,
      placeholder: "First name",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Middle name",
      helperText: errors && errors.middle_name && "Please enter middle name",
      name: "middle_name",
      value: middle_name,
      placeholder: "Middle name",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Last name*",
      helperText: errors && errors.last_name && "Please enter last name",
      name: "last_name",
      value: last_name,
      placeholder: "Last name",
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: "Suffix",
      name: "suffixes",
      value: suffixes,
      placeholder: "Select a suffix",
      selectOptions: suffixesSelector,
      itemArr: suffixesSelector,
      handleChange: handleInputChange,
      dropDown: "Suffix",
      field_name: "suffix",
    },
    {
      componentType: "SelectSpecific",
      label: "Gender",
      name: "gender_id",
      value: gender_id,
      placeholder: "Select a gender",
      selectOptions: genders?.filter((e) => e?.value.toLowerCase() !== "other"),
      handleChange: handleInputChange,
      dropDown: "Gender",
      field_name: "gender",
      addOptionText: "Other",
    },
    {
      componentType: "datePicker",
      required: true,
      label: "Date of birth",
      name: "dob",
      value: dob,
      futureDateHide: true,
      handleChange: handleInputChange,
    },
    // {
    //   componentType: "select",
    //   label: "Access Level*",
    //   helperText:
    //     errors && errors.access_level && "Please select an access level",
    //   name: "access_level",
    //   value: access_level,
    //   placeholder: "Access level",
    //   selectOptions: access_levels,
    //   handleChange: handleInputChange,
    // },
    {
      componentType: "select",
      // label: feildIsMandatory === false ? "Authorised to Access the Service":"Authorised to Access the Service*",
      label: "Authorisation to access the service Y/N",
      helperText:
        errors &&
        errors.authorisation_to_access_the_service &&
        "Please Yes or No",
      name: "authorisation_to_access_the_service",
      value: authorisation_to_access_the_service,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes" },
        { id: "No", value: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      label:
        feildIsMandatory === false
          ? "Authorisation provided by"
          : "Authorisation provided by",
      helperText:
        errors &&
        errors.authorisation_provided_by &&
        "Please enter Authorisation Provided By",
      name: "authorisation_provided_by",
      value: authorisation_provided_by,
      placeholder: "Authorisation provided by",
      // selectOptions: [
      //   { id: "Yes", value: "Yes", name: "Yes" },
      //   { id: "No", value: "No", name: "No" },
      // ],
      handleChange: handleInputChange,
    },

    {
      componentType: "SelectSpecific",

      label: "Nationality",
      helperText:
        errors && errors.nationality_list_id && "Please enter Nationality",
      name: "nationality_list_id",
      id: "nationality_list_id",
      placeholder: "Select country",
      selectOptions: country_lists,
      value: nationality_list_id,
      handleChange: handleInputChange,
    },
    {
      componentType: "select",
      // label: feildIsMandatory === false ? "Bame" : "Bame*",
      label: "BAME",
      helperText: errors && errors.bame && "Please Yes or No",
      name: "bame",
      value: bame,
      placeholder: "Select yes or no",
      selectOptions: [
        { id: "Yes", value: "Yes" },
        { id: "No", value: "No" },
      ],
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Ethnicity",
      // helperText: errors && errors.first_name && "Please enter first name",
      name: "ethnicity",
      value: ethnicity,
      placeholder: "Ethnicity",
      handleChange: handleInputChange,
    },
    {
      componentType: "multiSelectChip",
      label: userRole === "employee" ? "Languages*" : "Languages",
      name: "languages_list",
      placeholder: "Select languages",
      itemArr: language_lists,
      id: "languages_list",
      value: languages_list,
      handleChange: handleInputChange,
      helperText: errors && errors.languages_list && "Please select languages",
    },

    {
      componentType: "input",
      type: "text",
      label: "Home address",
      name: "address",
      value: address,
      placeholder: "Home address",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      // label: "Home Street",
      name: "address_line1",
      value: address_line1,
      placeholder: "Home address line1",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      // label: "Home town/city",
      name: "address_line2",
      value: address_line2,
      placeholder: "Home address line2",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      // label: "City",
      name: "city",
      value: city,
      placeholder: "Home city/town",
      // selectOptions: [
      //   { id: 1, value: "Manchester", name: "Manchester" },
      //   { id: 2, value: "London", name: "London" },
      // ],
      // selectOptions: cityList,
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      // label: "Home county",
      name: "county",
      value: county,
      placeholder: "Home county/state/region",

      handleChange: handleInputChange,
    },
    // {
    //   componentType: "input",
    //   type: "text",
    //   // label: "Home town/city",
    //   grid:"half",
    //   name: "postcode",
    //   value: postcode,
    //   placeholder: "Postcode",
    //   handleChange: handleInputChange,

    //   componentType1: "SelectSpecific",
    //   // label: "Home country",
    //   grid1:"half",
    //   name1: "country_list_id",
    //   value1: country_list_id,
    //   placeholder1: "Select home country",
    //   // apiVariable: "countries",
    //   selectOptions1: country_lists,
    //   handleChange1: handleInputChange,
    // },
    // {
    //   componentType: "inputWithDropdown",
    //   label: "Revenue currency",
    //   type: "number",
    //   inputName: "revenue",
    //   selectName: "revenue_currency_id",
    //   inputPlaceholder: "$00,000,000",
    //   selectPlaceholder: "USD",
    //   // apiVariable: "currencies",
    //   selectOptions: currencies,
    //   handleInputChange: handleInputChange,
    //   handleSelectChange: handleInputChange,
    //   inputValue: revenue,
    //   selectValue: revenue_currency_id,
    //   selectWithAutoComplete: true
    // },
    {
      componentType: "inputWithDropdown",
      label: "",
      grid: "yes",
      type: "text",
      name: "postcode",
      inputName: "postcode",
      selectName: "country_list_id",
      inputPlaceholder: "Home post/zip code",
      selectPlaceholder: "Select home country",
      selectOptions: country_lists,
      handleInputChange: handleInputChange,
      handleSelectChange: handleInputChange,
      inputValue: postcode,
      selectValue: country_list_id,
      selectWithAutoComplete: true,
    },
    // {
    //   componentType: "SelectSpecific",
    //   // label: "Home country",
    //   grid:"half",
    //   name: "country_list_id",
    //   value: country_list_id,
    //   placeholder: "Select home country",
    //   // apiVariable: "countries",
    //   selectOptions: country_lists,
    //   handleChange: handleInputChange,
    // },
    // {
    //   componentType: "phone",
    //   type: "number",
    //   // label: "Mobile",
    //   grid:"yes",
    //   name: "mobile",
    //   value: mobile,
    //   placeholder: "Mobile",
    //   handleChange: handleInputChange,
    //   errorMsg: errors && errors.mobile && "Please enter a mobile number",
    // },
    // {
    //   componentType: "phone",
    //   // label: "Telephone",
    //   grid:"yes",
    //   name: "phone",
    //   value: phone,
    //   placeholder: "Phone",
    //   handleChange: handleInputChange,
    //   errorMsg: errors && errors.phone && "Please enter a Phone number",
    // },
    {
      componentType: "input",
      type: "text",
      label: "Primary email*",
      name: "primary_email",
      value: primary_email,
      placeholder: "Primary email",
      handleChange: handleInputChange,
      helperText:
        errors && errors.primary_email && "Please enter a valid email",
    },
    {
      componentType: "input",
      type: "text",
      label: "Secondary email",
      name: "secondary_email",
      value: secondary_email,
      placeholder: "Secondary email",
      handleChange: handleInputChange,
    },
    {
      componentType: "phone",
      type: "number",
      label: "Mobile",
      name: "mobile",
      value: mobile,
      placeholder: "Mobile",
      handleChange: handleInputChange,
      errorMsg: errors && errors.mobile && "Please enter a mobile number",
    },
    {
      componentType: "phone",
      label: "Telephone",
      name: "phone",
      value: phone,
      placeholder: "Telephone",
      handleChange: handleInputChange,
      errorMsg: errors && errors.phone && "Please enter a Phone number",
    },
    {
      componentType: "input",
      type: "text",
      label: "LinkedIn",
      name: "linkedin",
      value: linkedin,
      placeholder: "LinkedIn url",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Skype",
      name: "skype",
      value: skype,
      placeholder: "Skype url",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Twitter ID",
      name: "twitter",
      value: twitter,
      placeholder: "Twitter url",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Facebook",
      name: "facebook",
      value: facebook,
      placeholder: "Facebook url",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Website 1",
      name: "website1",
      value: website1,
      placeholder: "Website url",
      handleChange: handleInputChange,
    },
    {
      componentType: "input",
      type: "text",
      label: "Website 2",
      name: "website2",
      value: website2,
      placeholder: "Website url",
      handleChange: handleInputChange,
    },
    {
      componentType: "imageUploadWithCrop",
      label: "Picture",
      // errorMsg: ".png, .jpg",
      existingImage: props.existingImage || null,
      setImageBlob: props.setImageBlob,
      // section: "org",
      cropProps: { unit: "%", width: 45, height: 40 },
      previewStyle: {
        width: "400px",
        height: "150px",
        borderRadius: 0,
      },
      imgPreviewProps: {
        width: "400px",
        height: "150px",
        style: {
          borderRadius: 0,
        },
      },
    },
  ]
    .map(formDisabler)
    .filter((item) =>
      userRole === "employee"
        ? !hideField.includes(item.label)
        : userRole === "admin"
        ? !hideAdminFields.includes(item.name)
        : item
    );

  const [formInput, setFormInput] = useState(formArray);

  useEffect(() => {
    setFormInput(formArray);
  }, [errors, titles, middle_name, props.existingImage]);

  return (
    <FormGenerator
      children={formInput}
      nextIndex={1}
      // setId={props.setId}
    />
  );
}
